<template>
  <div>
    <!-- หน้ารอโหลด -->
    <div
      v-if="isLoading"
    >
      <div class="loading-spinner">
        <div class="dot" />
        <div class="dot" />
        <div class="dot" />
      </div>
    </div>

    <div v-else>
      <div>
        <h2> {{ $t('search') }}</h2>
        <input
          v-model="searchQuery"
          type="text"
          :placeholder="$t('searchcateAndsubname')"
          class="form-input"
        >
      </div>
      <!-- Form for Adding/Editing Category -->
      <div class="form-container">
        <h2>{{ isEditingCategory ? $t('editlist') : $t('addcate') }}</h2>
        <form @submit.prevent="saveCategory">
          <input
            v-model="currentCategory.nameCate"
            maxlength="50"
            :placeholder="$t('catename')"
            required
            class="form-input"
          >
          <b-button
            type="submit"
            :variant="isEditingCategory ? 'warning' : 'primary'"
          >
            {{ isEditingCategory ? $t('edit') : $t('add') }}
          </b-button>

          <b-button
            variant="secondary"
            @click="resetToAddCategory"
          >
            {{ $t('reset') }}
          </b-button>
        </form>
      </div>

      <!-- Form for Adding/Editing Subcategory -->
      <div
        v-if="selectedCategory"
        class="form-container"
      >
        <h2>{{ isEditingSubCategory ? $t('editsubcate') : $t('addsubcate') }} {{ currentCategory.nameCate }} </h2>
        <form @submit.prevent="saveSubCategory">
          <input
            v-model="currentSubCategory.name"
            maxlength="50"
            :placeholder="$t('subcatename')"
            required
            class="form-input"
          >
          <b-button
            type="submit"
            :variant="isEditingSubCategory ? 'warning' : 'primary'"
          >
            {{ isEditingSubCategory ? $t('edit') : $t('addlist') }}
          </b-button>
        </form>
      </div>

      <!-- Categories List -->
      <div class="list-container">
        <ul class="category-list">
          <li
            v-for="category in filteredCategories"
            :key="category.id"
            class="category-item"
          >
            <span class="category-name">{{ category.nameCate }}</span>
            <div class="button-group">
              <b-button
                class="b-btn"
                variant="warning"
                size="sm"
                @click="editCategory(category)"
              >
                {{ $t('edit') }}
              </b-button>

              <b-button
                class="b-btn"
                variant="danger"
                size="sm"
                @click="deleteCategory(category.id)"
              >
                {{ $t('delete') }}
              </b-button>

              <b-button
                variant=""
                size="sm"
                class="clickable-icon"
                @click="toggleSubCategories(category.id)"
              >
                {{ isSubCategoriesVisible[category.id] ? $t('Collapse') : $t('Expand') }}
              </b-button>

            </div>

            <!-- Show subcategories directly under the category -->
             <b-table
              v-if="isSubCategoriesVisible[category.id]"
              :items="category.subCategories"
              :fields="['name', 'actions']"
              small
              bordered
              responsive
            >
              <template #head(name)>
                <span
                  class="font-weight-bold"
                  style="font-size: 14px;"
                >
                  {{ $t('subcatename') }}
                </span>
              </template>

              <template #head(actions)>
                <span
                  class="font-weight-bold"
                  style="font-size: 14px;"
                >
                  {{ $t('management') }}
                </span>
              </template>

              <template #cell(name)="data">
                {{ data.item.name }}
              </template>

              <template #cell(actions)="data">
                <b-button
                  variant="warning"
                  size="sm"
                  @click="editSubCategory(data.item, category.id)"
                >
                  {{ $t('edit') }}
                </b-button>
                <b-button
                  variant="danger"
                  size="sm"
                  @click="deleteSubCategory(data.item.id)"
                >
                  {{ $t('delete') }}
                </b-button>
              </template>
            </b-table>
          </li>
        </ul>
      </div>

      <!-- Confirmation Modal -->
      <div
        v-if="showConfirmationModal"
        class="modal-overlay"
      >
        <b-modal
          v-model="showConfirmationModal"
          :title="$t('delconfirm')"
          :ok-title="$t('yes')"
          :cancel-title="$t('cancel')"
          @ok="confirmDelete"
        >
          <p class="my-4">
            {{ $t('confirmdelete') }}
          </p>
        </b-modal>
      </div>
    </div>
  </div>
</template>

<script>
import apiSetting from '@/services/Setting'

export default {
  data() {
    return {
      searchQuery: '',
      categories: [],
      subCategories: [],
      selectedCategory: null,
      currentCategory: { id: null, nameCate: '' },
      currentSubCategory: { id: null, name: '', categoryId: null },
      isEditingCategory: false,
      isEditingSubCategory: false,
      loading: false,
      errorMessage: '',
      showConfirmationModal: false,
      itemToDelete: null, // ใช้เก็บ ID ของรายการที่จะลบ
      isSubCategoriesVisible: {}, // สถานะสำหรับการแสดง/ซ่อนหมวดหมู่ย่อย
      isLoading: true,
    }
  },
  computed: {
    filteredCategories() {
      return this.categories.filter(category => {
      // ค้นหาจากชื่อหมวดหมู่หลัก
        const categoryMatches = category.nameCate.toLowerCase().includes(this.searchQuery.toLowerCase())

        // ค้นหาจากหมวดหมู่ย่อย
        const subCategoriesMatch = category.subCategories && category.subCategories.some(subCategory => subCategory.name.toLowerCase().includes(this.searchQuery.toLowerCase()))

        // คืนค่าหมวดหมู่ถ้าตรงกับการค้นหาหรือถ้ามีหมวดหมู่ย่อยที่ตรง
        return categoryMatches || subCategoriesMatch
      })
    },
  },
  created() {
    this.fetchCategories()
  },
  methods: {
    toggleSubCategories(categoryId) {
      // สลับการแสดง/ซ่อนหมวดหมู่ย่อย
      this.$set(this.isSubCategoriesVisible, categoryId, !this.isSubCategoriesVisible[categoryId])
      if (!this.isSubCategoriesVisible[categoryId]) {
        this.selectedCategory = null // ถ้าซ่อนรายการ, ไม่เลือกหมวดหมู่
      } else {
        this.selectedCategory = this.categories.find(cat => cat.id === categoryId)
        this.fetchSubCategories(categoryId)
      }
    },

    async fetchCategories() {
      try {
        this.isLoading = true
        const response = await apiSetting.get('/cate') // ตรวจสอบ endpoint
        this.categories = response.data
        this.categories.forEach(category => {
          this.$set(this.isSubCategoriesVisible, category.id, false) // เริ่มต้นสถานะการซ่อน
        })
      } catch (error) {
        this.errorMessage = 'Error fetching categories.'
        console.error('Error fetching categories:', error)
      } finally {
        this.isLoading = false
      }
    },
    async fetchSubCategories(categoryId) {
      try {
        this.isLoading = true
        const response = await apiSetting.get(`/subcate/${categoryId}`) // ตรวจสอบ endpoint
        const category = this.categories.find(cat => cat.id === categoryId)
        if (category) {
          category.subCategories = response.data // เพิ่มหมวดหมู่ย่อยเข้าไปในหมวดหมู่ที่เลือก
        }
      } catch (error) {
        this.errorMessage = 'Error fetching subcategories.'
        console.error('Error fetching subcategories:', error)
      } finally {
        this.isLoading = false
      }
    },
    async saveCategory() {
      try {
        this.isLoading = true
        if (this.isEditingCategory) {
          await apiSetting.put(`/cateUpdate/${this.currentCategory.id}`, this.currentCategory) // ตรวจสอบ endpoint
        } else {
          await apiSetting.post('/cateAdd', this.currentCategory) // ตรวจสอบ endpoint
        }
        this.fetchCategories()
        this.resetCategoryForm()
      } catch (error) {
        this.errorMessage = 'Error saving category.'
        console.error('Error saving category:', error)
      } finally {
        this.isLoading = false
      }
    },
    async deleteCategory(categoryId) {
      this.itemToDelete = categoryId
      this.showConfirmationModal = true
    },
    async deleteSubCategory(subCategoryId) {
      this.itemToDelete = subCategoryId
      this.showConfirmationModal = true
    },
    async confirmDelete() {
      if (this.itemToDelete) {
        try {
          this.loading = true
          const isCategory = this.categories.some(cat => cat.id === this.itemToDelete)
          if (isCategory) {
            await apiSetting.delete(`/cateDel/${this.itemToDelete}`)
          } else {
            await apiSetting.delete(`/subcateDel/${this.itemToDelete}`)
          }
          this.$emit('delete-success')
          this.fetchCategories() // รีเฟรชข้อมูลหลังจากลบ
        } catch (error) {
          this.errorMessage = 'Error deleting item.'
          console.error('Error deleting item:', error.response ? error.response.data : error.message)
          // แสดง Toast ข้อความผิดพลาด
          this.$bvToast.toast(this.$t('useddelete'), {
            title: this.$t('error'),
            variant: 'danger',
            solid: true,
            appendToast: true,
            autoHideDelay: 5000,
            toaster: 'b-toaster-top-right',
          })
        } finally {
          this.loading = false
          this.itemToDelete = null
        }
      }
      this.showConfirmationModal = false
    },
    async saveSubCategory() {
      try {
        this.loading = true
        const payload = {
          name: this.currentSubCategory.name,
          category: {
            id: this.selectedCategory.id,
            nameCate: this.selectedCategory.nameCate,
          },
        }

        if (this.isEditingSubCategory) {
          await apiSetting.put(`/subcateUpdate/${this.currentSubCategory.id}`, payload)
        } else {
          await apiSetting.post('/subcateAdd', payload)
        }

        this.fetchCategories() // รีเฟรชข้อมูลทั้งหมดรวมถึงหมวดหมู่ย่อย
        this.resetSubCategoryForm()
      } catch (error) {
        this.errorMessage = 'Error saving subcategory.'
        console.error('Error saving subcategory:', error.response ? error.response.data : error.message)
      } finally {
        this.loading = false
      }
    },
    cancelDelete() {
      this.itemToDelete = null
      this.showConfirmationModal = false
    },
    editCategory(category) {
      this.currentCategory = { ...category }
      this.isEditingCategory = true
    },
    editSubCategory(subCategory, categoryId) {
      this.currentSubCategory = { ...subCategory, categoryId }
      this.isEditingSubCategory = true
      this.currentCategory = this.categories.find(cat => cat.id === categoryId)
    },
    resetCategoryForm() {
      this.currentCategory = { id: null, nameCate: '' }
      this.isEditingCategory = false
    },
    resetSubCategoryForm() {
      this.currentSubCategory = { id: null, name: '', categoryId: null }
      this.isEditingSubCategory = false
    },
    resetToAddCategory() {
      this.resetCategoryForm()
      this.resetSubCategoryForm()
      this.isSubCategoriesVisible = {}
      this.selectedCategory = null
    },
  },
}
</script>

  <style scoped>
  .container {
    padding: 20px;
  }

  .form-container {
    margin-top: 50px;
  }

  .b-btn {
    margin-right: 10px;
  }

  .form-input {
    padding: 10px;
    margin-right: 10px;
    border: 1px solid #ccc;
    border-radius: 5px;
  }

  .submit-btn {
    background-color: #5bc0de;
    color: white;
  }

  .btn {
    padding: 10px 20px;
    margin: 5px;
    border: none;
    border-radius: 5px;
    cursor: pointer;
  }

  .list-container {
    margin-top: 20px;
  }

  .category-list, .subcategory-list {
    list-style-type: none;
    padding: 0;
  }

  .category-item, .subcategory-item {
    padding: 10px;
  }

  .modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .sub-btn{
    font-size: 0.75rem;
  }

  .button-group b-icon {
    margin-left: 10px; /* ระยะห่างด้านซ้าย */
    margin-top: 2px; /* ปรับระยะห่างลงด้านบน */
}

.button-group {
    display: flex; /* ใช้ flex เพื่อจัดการตำแหน่ง */
    align-items: center; /* จัดให้ไอคอนอยู่กลางกับชื่อ */
}

  .modal-content {
    background: white;
    padding: 20px;
    border-radius: 5px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    text-align: center;
    width: 300px; /* เพิ่มความกว้างที่ต้องการ */
    margin: 0 auto; /* จัดให้อยู่กลางหน้าจอ */
  }

  .category-name{
    font-size: large;
    font-weight: bold;
  }

  .subcategory-name{
    font-size: medium;
  }

  .loading-spinner {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
}

.clickable-icon {
  cursor: pointer; /* เปลี่ยนเคอร์เซอร์เป็นมือเมื่อชี้ที่ไอคอน */
  margin-right: 10px; /* เพิ่มระยะห่างระหว่างไอคอน */
  margin-bottom: 5px;
}
.icon-large {
  font-size: 24px; /* กำหนดขนาดไอคอน (ปรับตามต้องการ) */
}
.icon-edit {
  font-size: 16px; /* กำหนดขนาดไอคอน (ปรับตามต้องการ) */
}

.dot {
  width: 15px;
  height: 15px;
  border-radius: 50%;
  background-color: #5496ec;
  animation: bounce 0.6s infinite alternate;
}

.dot:nth-child(2) {
  animation-delay: 0.2s;
}

.dot:nth-child(3) {
  animation-delay: 0.4s;
}

@keyframes bounce {
  0% {
    transform: translateY(0);
  }
  100% {
    transform: translateY(-20px);
  }
}
</style>
